var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 102,
    viewBox: "0 0 160 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "none",
    stroke: "none",
    d: "M -22 -21.999863 L 181.208954 -21.999863 L 181.208954 121.99987 L -22 121.99987 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#ff5f00",
    stroke: "none",
    d: "M 58.54879 12.262466 L 100.548706 12.262466 L 100.548706 87.737534 L 58.54879 87.737534 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#eb001b",
    stroke: "none",
    d: "M 61.215736 50 C 61.202263 35.271759 67.96283 21.355606 79.548866 12.262482 C 59.869095 -3.206322 31.606007 -0.954903 14.623371 17.434387 C -2.359304 35.823677 -2.359304 64.176331 14.623371 82.565613 C 31.606007 100.954903 59.869095 103.206322 79.548866 87.737518 C 67.962914 78.644356 61.202385 64.728203 61.215736 50 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#f79e1b",
    stroke: "none",
    d: "M 157.209 50 C 157.209702 68.376839 146.717728 85.140968 130.189041 93.172775 C 113.660339 101.20462 93.996597 99.09407 79.548866 87.737518 C 91.124084 78.635689 97.881927 64.725113 97.881927 50 C 97.881927 35.274887 91.124084 21.364311 79.548866 12.262482 C 93.996597 0.90593 113.660339 -1.20462 130.189041 6.827225 C 146.717728 14.859032 157.209702 31.623161 157.209 50 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "#f79e1b",
    stroke: "none",
    d: "M 152.629547 79.743561 L 152.629547 78.198349 L 153.252594 78.198349 L 153.252594 77.88353 L 151.665802 77.88353 L 151.665802 78.198349 L 152.289139 78.198349 L 152.289139 79.743561 Z M 155.71019 79.743561 L 155.71019 77.880478 L 155.223816 77.880478 L 154.664368 79.161934 L 154.104767 77.880478 L 153.618073 77.880478 L 153.618073 79.743561 L 153.961533 79.743561 L 153.961533 78.338203 L 154.486191 79.549835 L 154.842346 79.549835 L 155.367004 78.335152 L 155.367004 79.743561 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.b85298a7aafe5bc1be8dc1da5be85ecf.svg";
export { ForwardRef as ReactComponent };